import React from 'react';
import { CARD_LONG as W, CARD_SHORT as H } from '../../catalog';
import { V, T } from '../primitives';
import { CardFaceProps, DetailGrid, Logo, Photo, Validity, faceBase, faceData, nameStyle, type } from './shared';

const EDGE = 5;

/** Minimal — a white card with a single colour edge; type does the work. */
const MinimalFront: React.FC<CardFaceProps> = (props) => {
  const { design, person, photo, school, validUntil } = props;
  const { palette, details } = faceData(props);
  return (
    <V style={[faceBase(W, H, palette.paper), { flexDirection: 'row' }]}>
      <V style={{ width: EDGE, height: H, backgroundColor: palette.primary }}>
        <V style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 30, backgroundColor: palette.accent }} />
      </V>

      <V style={{ flex: 1, paddingLeft: 13, paddingRight: 12, paddingTop: 11 }}>
        {/* School */}
        <V style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Logo school={school} size={20} palette={palette} />
          <V style={{ flex: 1, marginLeft: 7 }}>
            <T style={{ fontSize: 7.4, fontWeight: 700, color: palette.ink, letterSpacing: -0.1 }} lines={1}>{school.name}</T>
            <T style={[type.caps, { fontSize: 4.2, color: palette.primaryText, marginTop: 1.5 }]} lines={1}>{design.title}</T>
          </V>
        </V>
        <V style={{ height: 0.7, backgroundColor: palette.hairline, marginTop: 8 }} />

        {/* Holder */}
        <V style={{ flexDirection: 'row', marginTop: 9 }}>
          <V style={{ flex: 1, paddingRight: 10 }}>
            <T style={[nameStyle(person.name, 12), { color: palette.ink }]} lines={2}>{person.name}</T>
            <V style={{ marginTop: 7 }}>
              <DetailGrid details={details} palette={palette} />
            </V>
          </V>
          <Photo photo={photo} name={person.name} width={52} height={64} radius={4} palette={palette} />
        </V>

        <V style={{ position: 'absolute', left: 13, right: 12, bottom: 9, flexDirection: 'row', alignItems: 'center' }}>
          <V style={{ flex: 1 }}>
            <Validity validUntil={validUntil} color={palette.ink} labelColor={palette.inkFaint} />
          </V>
          <T style={[type.caps, { fontSize: 4.3, color: palette.primaryText }]}>{design.audience === 'student' ? 'Student' : 'Staff'}</T>
        </V>
      </V>
    </V>
  );
};

export default MinimalFront;
